function initWorkConfidentialScroll() {
  const scrollTitle = document.querySelector(
    ".work-confidential__scroll-title",
  );
  if (!scrollTitle) return;

  let lastScrollY = window.scrollY;
  let ticking = false;
  const threshold = 5; // minimum px movement before changing direction

  function updateScrollDirection() {
    const currentScrollY = window.scrollY;
    const diff = currentScrollY - lastScrollY;

    // Only update if change is significant (prevents jerky toggling)
    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        scrollTitle.classList.add("is-scrolling-down");
        scrollTitle.classList.remove("is-scrolling-up");
      } else {
        scrollTitle.classList.add("is-scrolling-up");
        scrollTitle.classList.remove("is-scrolling-down");
      }

      lastScrollY = currentScrollY;
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollDirection);
      ticking = true;
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
}

function initWorkConfidentialLoadMore() {
  const loadMoreBtn = document.querySelector(".work-confidential__load");
  const scrollList = document.querySelector(".work-confidential__scroll-list");

  if (!loadMoreBtn || !scrollList) return;

  let currentIndex = 10;
  let projectsData = [];
  let isLoading = false;
  let isShowingLess = false;
  const initialItemCount = 10;

  function createProjectItem(project) {
    const li = document.createElement("li");
    li.className = "work-confidential__scroll-item";
    li.setAttribute("data-reveal-trigger", "");
    li.setAttribute("data-reveal-duration", "3");

    li.innerHTML = `
      <div class="work-confidential__item-industry">
        <h4>
          <span class="work-confidential__item-number">${project.number}</span>
          <span>${project.industry}</span>
        </h4>
      </div>
      <article class="work-confidential__item-desc">
        <h5>Description</h5>
        <p>${project.description}</p>
      </article>
      <article class="work-confidential__item-work">
        <h5>What we did</h5>
        <p>${project.work}</p>
      </article>
    `;

    return li;
  }

  function resetButtonAnimation(button) {
    if (!button) return;

    // Remove animation state classes and attributes
    button.classList.remove("is-revealed");
    button.removeAttribute("data-reveal-trigger-initialized");

    // Kill any existing ScrollTrigger instances for this button
    if (typeof ScrollTrigger !== "undefined") {
      const triggers = ScrollTrigger.getAll().filter(
        (trigger) => trigger.trigger === button,
      );
      triggers.forEach((trigger) => trigger.kill());
    }

    // Reset GSAP styles to initial animation state
    if (typeof gsap !== "undefined") {
      gsap.set(button, {
        opacity: 0.01,
        y: "50px",
        visibility: "visible",
        force3D: true,
        willChange: "transform, opacity",
        transformOrigin: "center center",
      });
    }

    // Note: The scroll reveal trigger will be re-initialized by the caller
    // after resetting the button, so we don't call it here to avoid double initialization
  }

  function showLess() {
    const allItems = scrollList.querySelectorAll(
      ".work-confidential__scroll-item",
    );

    for (let i = allItems.length - 1; i >= initialItemCount; i--) {
      allItems[i].remove();
    }

    currentIndex = initialItemCount;
    isShowingLess = false;
    loadMoreBtn.disabled = false;
    loadMoreBtn.textContent = "Load more";
    loadMoreBtn.title = "Click to see more projects";

    // Reset and re-animate the load more button
    resetButtonAnimation(loadMoreBtn);

    // Initialize scroll reveal triggers (button is handled in resetButtonAnimation)
    if (typeof window.initScrollRevealTrigger === "function") {
      window.initScrollRevealTrigger();
    }

    scrollList.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  async function loadMoreProjects() {
    if (isShowingLess) {
      showLess();
      return;
    }

    if (isLoading) return;

    isLoading = true;
    loadMoreBtn.disabled = true;
    loadMoreBtn.textContent = "Loading...";
    loadMoreBtn.title = "Loading projects...";

    try {
      if (projectsData.length === 0) {
        const possiblePaths = [
          "./assets/data/work-confidential-projects.json",
          "assets/data/work-confidential-projects.json",
          "/assets/data/work-confidential-projects.json",
        ];

        let response = null;
        let fetchError = null;

        for (const path of possiblePaths) {
          try {
            response = await fetch(path);
            if (response.ok) {
              projectsData = await response.json();
              break;
            }
          } catch (err) {
            fetchError = err;
            continue;
          }
        }

        if (projectsData.length === 0) {
          throw new Error(
            `Failed to fetch projects data. Tried paths: ${possiblePaths.join(", ")}. ` +
              `Error: ${fetchError?.message || "Unknown error"}`,
          );
        }
      }

      const data = projectsData;

      const itemsToLoad = Math.min(5, data.length - currentIndex);

      if (itemsToLoad <= 0) {
        isLoading = false;
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = "Show less";
        loadMoreBtn.title = "Click to hide additional projects";
        isShowingLess = true;
        return;
      }

      const fragment = document.createDocumentFragment();
      const newItems = [];

      for (let i = 0; i < itemsToLoad; i++) {
        if (currentIndex < data.length) {
          const project = data[currentIndex];
          const item = createProjectItem(project);
          fragment.appendChild(item);
          newItems.push(item);
          currentIndex++;
        }
      }

      scrollList.appendChild(fragment);

      // Reset and re-animate the load more button
      resetButtonAnimation(loadMoreBtn);

      // Initialize scroll reveal triggers for new items (button is handled in resetButtonAnimation)
      if (typeof window.initScrollRevealTrigger === "function") {
        window.initScrollRevealTrigger();
      }

      if (currentIndex >= data.length) {
        isShowingLess = true;
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = "Show less";
        loadMoreBtn.title = "Click to hide additional projects";
      } else {
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = "Load more";
        loadMoreBtn.title = "Click to see more projects";
      }
    } catch (error) {
      console.error("Error loading projects:", error);
      loadMoreBtn.disabled = false;
      loadMoreBtn.textContent = "Load more";
      loadMoreBtn.title = "Click to see more projects";
      alert("Failed to load more projects. Please try again.");
    } finally {
      isLoading = false;
    }
  }

  loadMoreBtn.addEventListener("click", loadMoreProjects);
}

function initWorkConfidential() {
  initWorkConfidentialScroll();
  initWorkConfidentialLoadMore();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initWorkConfidential);
} else {
  initWorkConfidential();
}
